import { Link } from "react-router-dom"
import DashboardSideBar from "../../components/dashboardSidebar"
import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import useIsMobile from "../../hooks/useIsMobile";
import MobileFooter from "../../components/MobileFooter";
import MobileHeader from "../../components/MobileHeader";

const Settings = () =>{
    const isMobileView = useIsMobile();
    if (isMobileView) {
        const logout = () => { localStorage.clear(); window.location.replace('/login'); };
        const items = [
            { to: '/myprofile', ic: 'far fa-user', t: 'Edit profile' },
            { to: '/cars', ic: 'fas fa-car-side', t: 'My cars' },
            { to: '/oneWayAvailabilities', ic: 'fas fa-route', t: 'One-way availabilities' },
            { to: '/subscriptions', ic: 'far fa-id-badge', t: 'Subscriptions' },
            { to: '/ratings', ic: 'far fa-star', t: 'Ratings' },
            { to: '/terms', ic: 'far fa-file-lines', t: 'Terms & conditions' },
            { to: '/privacy', ic: 'far fa-shield', t: 'Privacy policy' },
        ];
        return (
            <>
                <SideBar />
                <main className="mlux">
                    <MobileHeader right={<Link to="/" className="mlux-avatar"><i className="fas fa-gauge-high"></i></Link>} />
                    <div className="mlux-greet" style={{ margin: '8px 4px 2px' }} data-rise="1">
                        <div className="kick">Preferences</div>
                        <div className="nm" style={{ fontSize: 24 }}>Settings</div>
                    </div>
                    <div className="mlux-card" style={{ padding: '4px 16px' }} data-rise="2">
                        {items.map((m, i) => (
                            <Link key={i} to={m.to} className="mlux-menu-item">
                                <span className="mic"><i className={m.ic}></i></span>
                                <span className="mt">{m.t}</span>
                                <i className="fas fa-chevron-right mlux-chev"></i>
                            </Link>
                        ))}
                    </div>
                    <button className="mlux-danger" style={{ marginTop: 14 }} onClick={logout}><i className="far fa-arrow-right-from-bracket"></i> Log out</button>
                </main>
                <MobileFooter />
            </>
        );
    }
    return (<>
    <Header/>
    <SideBar/>
        <main class="main">

       


        <div class="user-profile py-5">
            <div class="container">
                <div class="row">
                   <DashboardSideBar/>
                   <div class="col-lg-9">
                        <div class="user-profile-wrapper">
                            <div class="user-profile-card profile-setting">
                                <h4 class="user-profile-card-title">Settings</h4>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <h6 class="mb-3">Privacy Setting</h6>
                                        <div class="profile-privacy-setting">
                                            <form action="#">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" name="privacy-setting" value="1"
                                                        type="checkbox" role="switch" id="privacy-setting-1" checked/>
                                                    <label class="form-check-label" for="privacy-setting-1">Notify Me
                                                        When Booking Confirm</label>
                                                </div>
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" name="privacy-setting" value="2"
                                                        type="checkbox" role="switch" id="privacy-setting-2"/>
                                                    <label class="form-check-label" for="privacy-setting-2">I Want To
                                                        Receive Email Notify</label>
                                                </div>
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" name="privacy-setting" value="3"
                                                        type="checkbox" role="switch" id="privacy-setting-3" checked/>
                                                    <label class="form-check-label" for="privacy-setting-3">Hide My
                                                        Phone Number From Public</label>
                                                </div>
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" name="privacy-setting" value="4"
                                                        type="checkbox" role="switch" id="privacy-setting-4"/>
                                                    <label class="form-check-label" for="privacy-setting-4">Notify Me
                                                        When Booking Completed</label>
                                                </div>
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" name="privacy-setting" value="5"
                                                        type="checkbox" role="switch" id="privacy-setting-5" checked/>
                                                    <label class="form-check-label" for="privacy-setting-5">Make My
                                                        Profile Private</label>
                                                </div>
                                                <div class="my-4">
                                                    <button type="submit" class="theme-btn"><span
                                                            class="far fa-gear"></span>Update Settings</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <h6 class="mb-3">Delete Account</h6>
                                        <div class="user-profile-form">
                                            <form action="#">
                                                <div class="form-group">
                                                    <select class="select mb-4">
                                                        <option value>Choose Reason</option>
                                                        <option value="1">Reason One</option>
                                                        <option value="2">Reason Two</option>
                                                        <option value="3">Reason Three</option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <textarea class="form-control" cols="30" rows="4"
                                                        placeholder="Describe Your Reason"></textarea>
                                                </div>
                                                <div class="my-4">
                                                    <button type="submit" class="theme-btn"><span
                                                            class="far fa-trash-can"></span>Delete Account</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </main>
    <Footer/>
    </>
    )
}
export default Settings